import styled from 'styled-components'

import { colors } from '../../constants'
import Padding from '../Padding'

const Flex = styled.div`
    display: flex;
    flex-direction: column;
`

const Body = styled(Padding)`
    flex-grow: 4;
    max-height: 80%;
`

const HeaderGroup = styled(Padding)`
    color: ${colors.bluedark};
    font-weight: bold;
    height: 20%;
`

const ButtonsGroup = styled(Padding)`
    text-align: right;
`

export { Flex, Body, HeaderGroup, ButtonsGroup }
